import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { StyledTypography } from "components/StyledComponents/styledComponents.js";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  TextField,
  TableHead,
  Typography,
  Box,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  ViewButton,
  DeleteButton,
  StyledTableContainer,
  StyledButtonC,
  CustomTableCell,
  StyledAgGridContainer,
} from "components/StyledComponents/styledComponents.js";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { CustomPaper } from "components/Styles/globalStyles";
import Cookie from "js-cookie";
import { json, useNavigate } from "react-router-dom";
import URLs from "constants/urls";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useMaterialUIController } from "context";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import styled from "@mui/material/styles/styled";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

const StyledCloseButton = styled(Button)({
  backgroundColor: "#f5f5f5",
  color: "#666",
  marginRight: "10px",
  "&:hover": {
    backgroundColor: "#e0e0e0",
  },
});

export default function PayStructureMappingToEmployee() {
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [companyCode, setCompanyCode] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [structureData, setStructureData] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeName, setEmployeeName] = useState("");
  const [hiringDate, setHiringDate] = useState(new Date().toISOString().split("T")[0]);
  const [employeeData, setEmployeeData] = useState([]);
  const [unmappedEmployeeData, setUnmappedEmployeeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payStructures, setPayStructures] = useState([]);
  const [structureType, setStructureType] = useState("");
  const [structureName, setStructureName] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [value, setValue] = useState("");
  const hrms_token = Cookie.get("hrms_token");
  const [payStructId, setPayStructId] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [filteredStructures, setFilteredStructures] = useState([]);
  const [comapanyStructures, setCompanyStructures] = useState([]);
  const [employeePayMapId, setEmployeePayMapId] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openStructureDialog, setOpenStructureDialog] = useState(false);
  const [dialogStructureData, setDialogStructureData] = useState([]);
  const [totalCtc, setTotalCtc] = useState(0);

  const tabs = [{ label: "Structure Mapping" }, { label: "Mapped Structures" }];

  const columnDefs = [
    {
      headerName: "Applicant Name",
      field: "employeeName",
      sortable: true,
      filter: true,
      flex: 2,
      cellStyle: { fontWeight: "500" },
    },
    {
      headerName: "Actions",
      field: "actions",
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: (params) => (
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <ViewButton onClick={() => handleEditStructure(params.node.rowIndex)}>
            <EditIcon />
          </ViewButton>
          <DeleteButton onClick={() => handleOpenDialog(params.data)}>
            <DeleteIcon />
          </DeleteButton>
        </Box>
      ),
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      filter: true,
      flex: 1,
      cellStyle: { fontWeight: "500" },
    },
  ];

  const columnDefsTab1 = [
    {
      headerName: "Applicant Name",
      field: "employeeName",
      sortable: true,
      filter: true,
      flex: 2,
      cellStyle: { fontWeight: "500" },
    },
    {
      headerName: "Hiring Date",
      field: "hiringDate",
      sortable: true,
      filter: true,
      flex: 1.5,
      valueFormatter: (params) => formatDate(params.value) || "",
      cellStyle: { fontWeight: "500" },
    },
    {
      headerName: "CTC Per Year",
      field: "ctcPerYear",
      sortable: true,
      filter: true,
      flex: 1.5,
      valueFormatter: (params) =>
        params.value ? `₹ ${formatNumberWithCommas(params.value.toFixed(2))}` : "",
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      headerName: "Basic",
      field: "basic",
      sortable: true,
      filter: true,
      flex: 1.5,
      valueFormatter: (params) =>
        params.value ? `₹ ${formatNumberWithCommas(params.value.toFixed(2))}` : "",
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      headerName: "Actions",
      field: "actions",
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: (params) => (
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <StyledButton
            variant="contained"
            size="small"
            onClick={() => handlePostDetails(params.data)}
          >
            Add
          </StyledButton>
        </Box>
      ),
    },
  ];

  const handleTabChange = (event, newValue) => {
    resetFormData();
    setTabValue(newValue);
  };

  const resetFormData = () => {
    setSelectedEmployee(null);
    setEmployeeName("");
    setHiringDate(new Date().toISOString().split("T")[0]);
    setStructureData([]);
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setPayStructId(0);
    setEditMode(false);
  };

  const resetForm = () => {
    setCompanyCode("");
    setSelectedCompany(null);
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setStructureData([]);
    setSelectedEmployee(null);
    setEmployeeName("");
    setHiringDate("");
    setEmployeeData([]);
  };

  const jwt_token = Cookie.get("jwt_token");
  const navigate = useNavigate();
  const MInput = inputStyle();

  const structureTypeOptions = [
    { label: "ADDITION", value: "ADDITION" },
    { label: "DEDUCTION", value: "DEDUCTION" },
  ];

  const dropdownOptions = [
    { label: "FIXED", value: "FIXED" },
    { label: "PERCENT", value: "PERCENT" },
  ];

  const fetchApplicants = async () => {
    try {
      setLoading(true);
      const response = await fetch(URLs.hrmsGetAllApplicants, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hrms_token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Failed to fetch applicants: ${response.status}`);
      }

      const data = await response.json();
      // Map the applicant data to match the expected employee data structure
      const mappedData = data.map((applicant) => ({
        employeeRecordId: applicant.applicantId,
        employeeName: `${applicant.firstName || ""} ${applicant.lastName || ""}`.trim(),
        hiringDate: applicant.dateOfJoining
          ? Array.isArray(applicant.dateOfJoining)
            ? applicant.dateOfJoining.join("-")
            : applicant.dateOfJoining
          : "",
        role: { roleId: applicant.roleId },
        phoneNumber: applicant.phoneNumber || "",
        emailId: applicant.emailId || "",
        ctcPerYear: applicant.ctcPerYear || 0,
        basic: applicant.basic || 0,
        companyId: applicant.companyId,
        address: [
          applicant.doorNo,
          applicant.streetName,
          applicant.cityName,
          applicant.districtName,
          applicant.stateName,
          applicant.zipCode,
        ]
          .filter(Boolean)
          .join(", "),
      }));
      setEmployeeData(mappedData);
      setUnmappedEmployeeData(mappedData); // Set all applicants as unmapped
    } catch (error) {
      console.error("Error fetching applicants:", error);
      setAlert(error.message || "Failed to fetch applicants", "error");
      setEmployeeData([]);
      setUnmappedEmployeeData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchPayStruData = async () => {
    const url = `${URLs.hrmsPayStructsByCid}/${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${hrms_token}`,
      },
    };

    setLoading(true);
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`Failed to fetch company structures: ${response.status}`);
      }

      const data = await response.json();
      setCompanyStructures(data);
    } catch (error) {
      console.error("Error fetching company structures:", error);
      setAlert("Failed to fetch Pay Structure data", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchMappedStructures = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${URLs.hrmsGetAllApplicantsPayStructures}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hrms_token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch mapped structures");
      }

      const data = await response.json();

      // Find matching employees from employeeData for complete information
      const formattedData = data.map((item) => {
        const matchingEmployee = employeeData.find(
          (emp) => emp.employeeRecordId === item.applicantId
        );

        return {
          employeeName: matchingEmployee
            ? matchingEmployee.employeeName
            : `${item.firstName || ""} ${item.lastName || ""}`.trim(),
          applicantId: item.applicantId,
          status: item.status || "Active",
          // Store original data for reference
          firstName: item.firstName,
          lastName: item.lastName,
          // Add additional employee data if needed
          ctcPerYear: matchingEmployee?.ctcPerYear,
          basic: matchingEmployee?.basic,
        };
      });

      // Remove these applicants from unmappedEmployeeData
      const mappedIds = formattedData.map((item) => item.applicantId);
      setUnmappedEmployeeData((prev) =>
        prev.filter((emp) => !mappedIds.includes(emp.employeeRecordId))
      );

      setStructureData(formattedData);
      setMessage("Mapped structures fetched successfully");
      setAlertType("success");
      setOpen(true);
    } catch (error) {
      console.error("Error fetching mapped structures:", error);
      setMessage(error.message || "Failed to fetch mapped structures");
      setAlertType("error");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEmployee) {
      setEmployeeName(`${selectedEmployee.employeeName}`);
      setHiringDate(selectedEmployee.hiringDate);
    } else {
      setEmployeeName("");
      setHiringDate("");
      setStructureData([]);
    }
  }, [selectedEmployee]);

  useEffect(() => {
    if (structureType) {
      const filtered = comapanyStructures
        .filter((struct) => struct.structType === structureType)
        .map((struct) => ({
          label: struct.structName,
          value: struct.payStructId,
          type: struct.structPercentFixedType.trim(),
          amount: struct.structValue,
        }));
      setFilteredStructures(filtered);
    }
  }, [structureType, comapanyStructures]);

  useEffect(() => {
    if (tabValue === 1) {
      fetchMappedStructures();
    }
  }, [tabValue]);

  useEffect(() => {
    fetchApplicants();
    fetchPayStruData();
  }, []);

  const calculateAmount = (value, type, basic) => {
    if (type === "FIXED") {
      return parseFloat(value) || 0;
    } else if (type === "PERCENT") {
      return (parseFloat(value) * parseFloat(basic)) / 100 || 0;
    }
    return 0;
  };

  const updateTotalCtc = (structures) => {
    const structuresTotal = structures.reduce((sum, item) => {
      return sum + (item.amount || 0);
    }, 0);
    const basicPay = selectedEmployee?.basic || 0;
    setTotalCtc(structuresTotal + basicPay);
  };

  const handleAddToTable = () => {
    if (!structureType || !structureName || !dropdownValue || !value) {
      setAlert("Please fill in all fields", "error");
      return;
    }

    const amount = calculateAmount(value, dropdownValue, selectedEmployee?.basic || 0);
    const newStructure = {
      structureType,
      structureName,
      percentFixed: dropdownValue,
      value,
      amount,
      payStructId,
      // Include IDs for both new and edit modes
      applPayStructMapId: window.editingRow?.applPayStructMapId || 0,
      applicantId: selectedEmployee?.employeeRecordId,
    };

    const newData = [...dialogStructureData, newStructure];
    setDialogStructureData(newData);
    updateTotalCtc(newData);

    // Reset structure form fields
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setPayStructId(0);
    window.editingRow = null; // Clear the editing row data

    // Ensure we stay in post mode if we're in first tab
    if (tabValue === 0) {
      setEditMode(false);
    }
  };

  const handleRemoveFromTable = (index) => {
    const newData = dialogStructureData.filter((_, i) => i !== index);
    setDialogStructureData(newData);
    updateTotalCtc(newData);
  };

  const handleAddStructure = async () => {
    if (dialogStructureData.length === 0) {
      setAlert("Please add at least one structure", "error");
      return;
    }

    // 5% maintaing....for posting.
    const targetCtc = selectedEmployee?.ctcPerYear || 0;
    const minCtc = targetCtc * 0.95; // 5% below
    const maxCtc = targetCtc * 1.05; // 5% above

    if (totalCtc < minCtc || totalCtc > maxCtc) {
      setAlert("Total CTC must be within ±5% of the applicant's CTC", "error");
      return;
    }

    setLoading(true);

    try {
      if (editMode) {
        // For update, send all structures in a single request
        // Format the update payload as an array of structures
        const structures = dialogStructureData.map((structure) => {
          return {
            applPayStructMapId: structure.applPayStructMapId || 0, // Use 0 if ID is missing
            applicantId: selectedEmployee.employeeRecordId,
            payStructId: structure.payStructId,
            structValue:
              structure.percentFixed === "PERCENT" ? parseFloat(structure.value) : structure.amount,
            activeStatus: "Y",
          };
        });

        console.log("Update payload:", structures);

        const response = await fetch(
          `${URLs.hrmsUpdateApplicantPayStruct}/${selectedEmployee.employeeRecordId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${hrms_token}`,
            },
            body: JSON.stringify(structures),
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to update structures");
        }
      } else {
        // For new structures, create them one by one
        const promises = dialogStructureData.map((structure) => {
          const payload = {
            applicantId: selectedEmployee.employeeRecordId,
            payStructId: structure.payStructId,
            structValue:
              structure.percentFixed === "PERCENT" ? parseFloat(structure.value) : structure.amount,
            activeStatus: "Y",
          };

          return fetch(URLs.hrmsPostPayStructMapping, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${hrms_token}`,
            },
            body: JSON.stringify(payload),
          });
        });

        await Promise.all(promises);
      }

      handleCloseStructureDialog();
      setAlert(
        editMode ? "Structures updated successfully" : "Structures added successfully",
        "success"
      );

      // After successful addition/update, refresh the mapped structures
      await fetchMappedStructures();

      // Remove the mapped applicant from unmappedEmployeeData if this is a new mapping
      if (!editMode) {
        setUnmappedEmployeeData((prev) =>
          prev.filter((emp) => emp.employeeRecordId !== selectedEmployee.employeeRecordId)
        );
      }

      setTabValue(1); // Switch to mapped structures tab
    } catch (error) {
      console.error("Error:", error);
      setAlert(error.message || `Failed to ${editMode ? "update" : "add"} structures`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleStructureNameChange = (event, selectedOption) => {
    if (selectedOption) {
      setStructureName(selectedOption.label);
      setDropdownValue(selectedOption.type);
      setPayStructId(selectedOption.value);
      setValue(selectedOption.amount?.toString() || "");
    } else {
      setStructureName("");
      setDropdownValue("");
      setValue("");
      setPayStructId("");
    }
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const restFormInputs = () => {
    setEditMode(false);
    setPayStructId("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setStructureType("");
    setEmployeePayMapId("");
  };
  const handleEditStructure = async (index) => {
    const newStructure = structureData[index];
    console.log("Selected structure for edit:", newStructure);
    setEditMode(true);
    setLoading(true);

    try {
      // Find the employee from employeeData based on the name
      const matchingEmployee = employeeData.find(
        (emp) => emp.employeeRecordId === newStructure.applicantId
      );

      if (!matchingEmployee) {
        setAlert("Employee not found", "error");
        return;
      }

      console.log("Matching employee found:", matchingEmployee);

      // Set the selected employee first
      setSelectedEmployee(matchingEmployee);

      // Store the applicantId for later use
      window.currentApplicantId = newStructure.applicantId;

      // Fetch existing structure data using the new API endpoint
      const response = await fetch(
        `${URLs.hrmsGetPayStructDetailsById}/${newStructure.applicantId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${hrms_token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch structure details");
      }

      const structureDetails = await response.json();
      console.log("Raw API response:", structureDetails);

      // Format the structure data for the dialog
      const formattedStructures = structureDetails
        .map((structure) => {
          console.log("Processing structure:", structure);

          // Map the fields from the API response - using both possible field names
          const structType = structure.structType || structure.structureType || "";
          const structName = structure.structName || structure.structureName || "";
          const percentFixedType =
            structure.structPercentFixedType || structure.percentFixedType || "FIXED";
          const structValue = parseFloat(structure.structValue || structure.value || 0);
          const payStructId = parseInt(structure.payStructId || structure.payStructureId || 0, 10);
          const applPayStructMapId = parseInt(structure.applPayStructMapId || 0, 10);
          const applicantId = window.currentApplicantId;

          console.log("Mapped fields:", {
            structType,
            structName,
            percentFixedType,
            structValue,
            payStructId,
          });

          // Ensure we have valid numeric values
          if (isNaN(structValue) || isNaN(payStructId)) {
            console.warn("Invalid numeric value in structure:", structure);
            return null;
          }

          const amount = calculateAmount(
            structValue,
            percentFixedType.trim(),
            parseFloat(matchingEmployee.basic || 0)
          );

          console.log("Calculated amount:", amount);

          // First try to find a matching structure in companyStructures
          const matchingStructure = comapanyStructures.find(
            (s) => s.payStructId === payStructId || s.structName === structName
          );

          // Use the matching structure's type if available, otherwise use the API response
          const finalStructType = matchingStructure?.structType || structType;

          return {
            structureType: finalStructType,
            structureName: structName,
            percentFixed: percentFixedType.trim(),
            value: structValue,
            amount: amount,
            payStructId: payStructId,
            applPayStructMapId: applPayStructMapId,
            applicantId: applicantId,
          };
        })
        .filter(Boolean); // Remove any null entries

      console.log("Final formatted structures:", formattedStructures);

      // Set the dialog data
      setDialogStructureData(formattedStructures);

      // Calculate total CTC including basic pay
      const structuresTotal = formattedStructures.reduce(
        (sum, item) => sum + (item.amount || 0),
        0
      );
      const basicPay = parseFloat(matchingEmployee.basic || 0);
      const totalWithBasic = structuresTotal + basicPay;
      console.log("Total CTC calculation:", {
        structuresTotal,
        basicPay,
        totalWithBasic,
      });
      setTotalCtc(totalWithBasic);

      // Open the dialog
      setOpenStructureDialog(true);
    } catch (error) {
      console.error("Error fetching structure details:", error);
      setAlert(error.message || "Failed to load structure details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteStructure = async () => {
    if (!selectedRow?.applicantId) {
      setAlert("Invalid applicant ID", "error");
      return;
    }

    setLoading(true);

    try {
      const url = `${URLs.hrmsDeletePayStructMapping}/${selectedRow.applicantId}`;
      console.log("Delete URL:", url);
      console.log("Selected Row:", selectedRow);

      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hrms_token}`,
        },
      };

      const response = await fetch(url, options);
      console.log("Delete Response Status:", response.status);

      if (!response.ok) {
        let errorMessage;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message;
        } catch (e) {
          errorMessage = `Failed to delete structure mapping: ${response.status}`;
        }
        throw new Error(errorMessage);
      }

      setAlert("Structure mapping deleted successfully", "success");
      handleCloseDialog();

      // Add the deleted applicant back to unmappedEmployeeData
      const deletedEmployee = employeeData.find(
        (emp) => emp.employeeRecordId === selectedRow.applicantId
      );
      if (deletedEmployee) {
        setUnmappedEmployeeData((prev) => [...prev, deletedEmployee]);
      }

      // Refresh the data after successful deletion
      await fetchMappedStructures();

      // Reset any selected items
      setSelectedRow(null);
    } catch (error) {
      console.error("Error deleting structure mapping:", error);
      setAlert(error.message || "Failed to delete structure mapping", "error");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleOpenDialog = (rowData) => {
    setSelectedRow(rowData);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleCloseStructureDialog = () => {
    setOpenStructureDialog(false);
    setDialogStructureData([]);
    setTotalCtc(0);
    setEditMode(false); // Reset edit mode when closing dialog
    window.editingRow = null; // Clear editing row data

    // Reset form fields
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setPayStructId(0);
  };

  const handleValueChange = (e) => {
    const rawValue = e.target.value.replace(/[^\d.]/g, "");
    const numericValue = parseFloat(rawValue);
    if (!isNaN(numericValue)) {
      setValue(rawValue);
    } else if (rawValue === "" || rawValue === ".") {
      setValue(rawValue);
    }
  };

  const handlePostDetails = (rowData) => {
    setSelectedEmployee(rowData);
    setEmployeeName(rowData.employeeName);
    setHiringDate(rowData.hiringDate);
    setEditMode(false);
    setOpenStructureDialog(true);
    setDialogStructureData([]); // Clear any existing structure data
  };

  const formatNumberWithCommas = (value) => {
    if (value === null || value === undefined) return "";
    // Convert to string if it's a number
    const stringValue = value.toString();
    // Remove any existing commas and non-numeric characters except decimal point
    const numericValue = stringValue.replace(/[^\d.]/g, "");
    // Format with commas
    const parts = numericValue.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  const handleEditTableRow = (index) => {
    const row = dialogStructureData[index];
    // Store all necessary IDs in window.editingRow
    window.editingRow = {
      applPayStructMapId: row.applPayStructMapId,
      payStructId: row.payStructId,
      applicantId: row.applicantId,
    };

    setStructureType(row.structureType);
    setStructureName(row.structureName);
    setDropdownValue(row.percentFixed);
    setValue(row.value.toString());
    setPayStructId(row.payStructId);

    // Only set editMode to true if we're in the second tab (tabValue === 1)
    // This ensures first tab stays in "Post" mode even when editing dialog table rows
    if (tabValue === 1) {
      setEditMode(true);
    }

    // Remove the edited row from the table
    const newData = dialogStructureData.filter((_, i) => i !== index);
    setDialogStructureData(newData);
    updateTotalCtc(newData);
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          height: "100vh",
          backgroundColor: "transparent",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* <Dialog
          open={loading}
          onClose={() => setLoading(false)}
          aria-labelledby="loading-dialog-title"
        >
          <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CircularProgress color="primary" />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog> */}

        <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="delete-dialog-title">
          <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
          <DialogContent>Are you sure you want to delete this structure?</DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleDeleteStructure}>Delete</Button>
          </DialogActions>
        </Dialog>

        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", mt: 0 }}>
          <ResponsiveTabs
            tabs={tabs}
            activeTab={tabValue}
            onChange={handleTabChange}
            labelColor="#1890ff"
            bgColor="#f0f7ff"
          />

          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              height: "calc(100vh - 120px)",
            }}
          >
            {tabValue === 0 ? (
              <Paper
                sx={{
                  p: 2,
                  borderRadius: "15px",
                  backgroundColor: "#ffffff",
                  width: "100%",
                  maxWidth: "1600px",
                  mx: "auto",
                  height: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <StyledAgGridContainer
                  className="ag-theme-alpine"
                  style={{
                    flexGrow: 1,
                    width: "100%",
                    height: "calc(75vh - 100px)",
                    minHeight: "200px",
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefsTab1}
                    rowData={unmappedEmployeeData}
                    pagination={true}
                    paginationPageSize={10}
                    defaultColDef={{
                      flex: 1,
                      minWidth: 150,
                      resizable: true,
                      sortable: true,
                      filter: true,
                    }}
                    rowHeight={48}
                    headerHeight={48}
                    animateRows={true}
                    enableCellTextSelection={true}
                    suppressRowClickSelection={true}
                    onGridReady={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                    onFirstDataRendered={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                  />
                </StyledAgGridContainer>
              </Paper>
            ) : (
              <Paper
                sx={{
                  p: 2,
                  borderRadius: "15px",
                  backgroundColor: "#ffffff",
                  width: "100%",
                  maxWidth: "1600px",
                  mx: "auto",
                  height: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <StyledAgGridContainer
                  className="ag-theme-alpine"
                  style={{
                    flexGrow: 1,
                    width: "100%",
                    height: "calc(75vh - 100px)",
                    minHeight: "200px",
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={structureData}
                    pagination={true}
                    paginationPageSize={10}
                    defaultColDef={{
                      flex: 1,
                      minWidth: 150,
                      resizable: true,
                      sortable: true,
                      filter: true,
                    }}
                    rowHeight={48}
                    headerHeight={48}
                    animateRows={true}
                    enableCellTextSelection={true}
                    suppressRowClickSelection={true}
                    onGridReady={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                    onFirstDataRendered={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                  />
                </StyledAgGridContainer>
              </Paper>
            )}
          </Box>
        </Box>

        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>

        <Dialog
          open={openStructureDialog}
          onClose={handleCloseStructureDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            {editMode ? "Update Structure Details" : "Post Structure Details"}
            <IconButton
              aria-label="close"
              onClick={handleCloseStructureDialog}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Applicant Name"
                  value={selectedEmployee?.employeeName || ""}
                  fullWidth
                  disabled
                  sx={MInput.b}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="CTC"
                  value={
                    selectedEmployee?.ctcPerYear
                      ? formatNumberWithCommas(selectedEmployee.ctcPerYear.toFixed(2))
                      : ""
                  }
                  fullWidth
                  disabled
                  sx={MInput.b}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Basic"
                  value={
                    selectedEmployee?.basic
                      ? formatNumberWithCommas(selectedEmployee.basic.toFixed(2))
                      : ""
                  }
                  fullWidth
                  disabled
                  sx={MInput.b}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={structureTypeOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    structureTypeOptions.find((option) => option.value === structureType) || null
                  }
                  onChange={(event, value) => setStructureType(value ? value.value : "")}
                  PaperComponent={CustomPaper}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="Structure Type" required sx={MInput.b} />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={filteredStructures}
                  getOptionLabel={(option) => option.label}
                  value={
                    filteredStructures.find((option) => option.label === structureName) || null
                  }
                  onChange={handleStructureNameChange}
                  fullWidth
                  PaperComponent={CustomPaper}
                  disabled={!structureType}
                  renderInput={(params) => (
                    <TextField {...params} label="Structure Name" required sx={MInput.b} />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Value"
                  value={value}
                  onChange={handleValueChange}
                  fullWidth
                  required
                  type="number"
                  inputProps={{ min: 0 }}
                  disabled={!structureType}
                  sx={MInput.b}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mb: 3 }}>
              <StyledButton variant="contained" onClick={handleAddToTable}>
                Add
              </StyledButton>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                mt: 2,
                width: "100%",
                overflowX: "hidden",
                "& .MuiTable-root": {
                  width: "100%",
                  tableLayout: "fixed",
                },
                "& .MuiTableCell-root": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "8px 16px",
                },
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "22%", fontWeight: 600, backgroundColor: "#f5f5f5" }}>
                      Structure Type
                    </TableCell>
                    <TableCell sx={{ width: "25%", fontWeight: 600, backgroundColor: "#f5f5f5" }}>
                      Structure Name
                    </TableCell>
                    <TableCell sx={{ width: "15%", fontWeight: 600, backgroundColor: "#f5f5f5" }}>
                      Percent/Fixed
                    </TableCell>
                    <TableCell
                      sx={{ width: "15%", fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      align="right"
                    >
                      Value
                    </TableCell>
                    <TableCell
                      sx={{ width: "15%", fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      align="right"
                    >
                      Amount
                    </TableCell>
                    <TableCell
                      sx={{ width: "8%", fontWeight: 600, backgroundColor: "#f5f5f5" }}
                      align="center"
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dialogStructureData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ width: "22%" }}>{row.structureType}</TableCell>
                      <TableCell sx={{ width: "25%" }}>{row.structureName}</TableCell>
                      <TableCell sx={{ width: "15%" }}>{row.percentFixed}</TableCell>
                      <TableCell sx={{ width: "15%" }} align="right">
                        {row.percentFixed === "PERCENT"
                          ? `${parseFloat(row.value).toFixed(2)}%`
                          : `₹${formatNumberWithCommas(parseFloat(row.value).toFixed(2))}`}
                      </TableCell>
                      <TableCell sx={{ width: "15%" }} align="right">
                        ₹{formatNumberWithCommas(parseFloat(row.amount || 0).toFixed(2))}
                      </TableCell>
                      <TableCell sx={{ width: "8%" }} align="center">
                        <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
                          <IconButton
                            onClick={() => handleEditTableRow(index)}
                            size="small"
                            sx={{ padding: "4px" }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            onClick={() => handleRemoveFromTable(index)}
                            size="small"
                            sx={{ padding: "4px" }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Paper
              elevation={0}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                mt: 2,
                p: 2,
                backgroundColor: "#f5f5f5",
                borderRadius: 1,
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mr: 2 }}>
                Total CTC:
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                ₹{formatNumberWithCommas(totalCtc.toFixed(2))}
              </Typography>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseStructureDialog}>Cancel</Button>
            <StyledButton variant="contained" onClick={handleAddStructure}>
              {editMode ? "Update" : "Add Structure"}
            </StyledButton>
          </DialogActions>
        </Dialog>
      </Box>
    </DashboardLayout>
  );
}
